module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-campaign-2-195ade00e16e783240cb8fc1c98e58cf.svg";